import type { PurchasePointsMetadata } from "@/features/purchasePoints/types/purchasePointsOffer.type";

/**
 * Bounds of the requested page, read off the active catalogue's metadata.
 * An empty catalogue announces no page at all: without the zero case, a deep
 * URL would offer neither pagination nor a way back, hence no way out.
 */
export const readCatalogPagination = (
  metadata: PurchasePointsMetadata | undefined,
  page: number,
) => {
  const totalPages = metadata?.total_pages ?? 0;

  return {
    totalPages,
    isBeyondLastPage: page > 1 && (totalPages === 0 || page > totalPages),
  };
};
